import htmlDocx from 'html-docx-js/dist/html-docx'
import saveAs from "file-saver";
const ExportHTMLToWord = (data, title) => {
    saveAs(htmlDocx.asBlob(data, { orientation: 'portrait ', font: 'Times New Roman' }), `${title}.docx`)
}

export default ExportHTMLToWord;